module.exports = __webpack_public_path__ + "static/img/bg.afaf17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = yEeP
// module chunks = 1